import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button, MenuItem } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import HighlightOff from '@material-ui/icons/HighlightOff';
import ArrowUpward from '@material-ui/icons/ArrowDropDownCircleOutlined';
import ArrowDownward from '@material-ui/icons/ArrowDropDownCircleOutlined';
import { ADD, globalData } from '../../../../common/common';
import { clone } from '../../../../common/utils';

const Root = styled(Box)({
    width: '100%',
    padding: '0 10px',
    '& .textWapper': {
        width: '50%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textWapper2': {
        width: '50%',
        paddingRight: '15px',
        '& .textField1': {
            width: '35%',
            backgroundColor: '#FFFFFF',
            paddingRight: '5px',
        },
        '& .textField2': {
            width: '65%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textWapperF': {
        width: '100%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .toolView': {
        width: '100%',
        // borderBottom: '1px dashed #EAE8EB',
        padding: '10px 0',
        '& .delWapper': {
            color: '#C1553A',
            cursor: 'pointer',
            '& .del': {
                width: '15px',
                marginRight: '5px',
            },
        },
        '& .arrowWapper': {
            color: '#009CEE',
            cursor: 'pointer',
            marginRight: '15px',
            '& .arrowUpIcon': {
                width: '15px',
                marginRight: '5px',
                transform: 'rotate(-180deg)',
            },
            '& .arrowIcon': {
                width: '15px',
                marginRight: '5px',
            },
        },
    },
    '& .dragBox': {
        width: '100%',
        height: '140px',
        border: '1px dashed #43D79E',
        borderRadius: '3px',
        fontSize: '16px',
        color: '#43D79E',
        opacity: '0.5',
    },
    '& .dragBox2': {
        width: '100%',
        height: '140px',
        border: '1px dashed #43D79E',
        borderRadius: '3px',
        fontSize: '16px',
        color: '#43D79E',
    },
    '& .panel-wapper': {
        width: '100%',
        marginTop: '10px',
        padding: '0 10px',
        minHeight: '200px',
        border: '1px dashed #EAE8EB',
        backgroundColor: '#FAFAFA',
        '& .text-wapper': {
            width: '50%',
            paddingRight: '15px',
            '& .text-field': {
                width: '100%',
                // backgroundColor: '#FFFFFF',
            },
        },
        '& .text-title': {
            marginTop: '10px',
            fontSize: '14px',
            color: '#9B9B9B',
        },
        '& .tool-view': {
            width: '100%',
            padding: '10px 0',
        },
    },
})

class AddMore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataArr: [
                {
                    ".CHO.N.": "",
                    ".CHO.Em": "",
                    ".CHO.AddrNPho": {
                        "phone": "",
                        "unit": "",
                        "street": "",
                        "city": "",
                        "country": "",
                        "state": "",
                        "zipcode": "",
                    },
                    ".CHO.Addr": {
                        "phone": "",
                        "unit": "",
                        "street": "",
                        "city": "",
                        "country": "",
                        "state": "",
                        "zipcode": "",
                    },
                    "rc": "",
                    "relation": "",
                    // "phone": "",
                    // "unit": "",
                    // "street": "",
                    // "city": "",
                    // "country": "",
                    // "state": "",
                    // "zipcode": "",
                },
            ],
            stateData: ["CN", "US"],
            rcData: ["Client's"],
            isCollision: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelet = this.handleDelet.bind(this);
        this.handleArrow = this.handleArrow.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
    }
    render() {
        const {
            dataArr,
            stateData,
            rcData,
            isCollision
        } = this.state;
        const { name, name2, haveEmail, lock, lockNum, adrsPhoKey } = this.props;
        const showArrowBtn = (index) => {
            if (dataArr.length <= 1) {
                return <div className="arrowWapper h">
                </div>
            }
            if (index < lockNum || dataArr.length <= lockNum + 1) {
                return <div className="arrowWapper h">
                </div>
            } else if (index === lockNum && dataArr.length > lockNum) {
                return <div className="h">
                    <div className="arrowWapper h" onClick={e => this.handleArrow(e, index, "down")}>
                        <ArrowDownward className="arrowIcon" /><div>MOVE DOWN</div>
                    </div>
                </div>
            } else if (index === dataArr.length - 1) {
                return <div className="h">
                    <div className="arrowWapper h" onClick={e => this.handleArrow(e, index, "up")}>
                        <ArrowUpward className="arrowUpIcon" /><div>MOVE UP</div>
                    </div>
                </div>
            } else {
                return <div className="h">
                    <div className="arrowWapper h" onClick={e => this.handleArrow(e, index, "up")}>
                        <ArrowUpward className="arrowUpIcon" /><div>MOVE UP</div>
                    </div>
                    <div className="arrowWapper h" onClick={e => this.handleArrow(e, index, "down")}>
                        <ArrowDownward className="arrowIcon" /><div>MOVE DOWN</div>
                    </div>
                </div>
            }
        }
        const showDelBtn = (index) => {
            if (lockNum && lockNum > index) {
                return <div className="delWapper">
                </div>
            }
            if (index !== 0) {
                return <div className="delWapper h" onClick={e => this.handleDelet(e, index)}>
                    <HighlightOff className="del d-e"></HighlightOff> DELETE
                </div>
            } else {
                return <div className="delWapper">
                </div>
            }
        }
        const unitView = (row, index, isInput = true) => {
            if (dataArr[index][adrsPhoKey]["country"] === "CN") {
                if (isInput) {
                    return <div className="textWapper">
                        <div className="textTitle">{name} Choice {index + 1} {name2} Unit</div>
                        <TextField
                            disabled={this.isDisabled(index)}
                            className="textField"
                            value={row[adrsPhoKey]["unit"]}
                            onChange={e => this.handleChange(e, index, 'unit')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                } else {
                    return <div className="text-wapper">
                        <div className="text-title">{name} Choice {index + 1} {name2} Unit</div>
                        <div>{row[adrsPhoKey]["unit"]}</div>
                    </div>
                }
            }
        }
        const emailView = (row, index, isInput = true) => {
            if (haveEmail) {
                if (isInput) {
                    return <div className="textWapper">
                        <div className="textTitle">{name} Choice {index + 1} Email (Optional)</div>
                        <TextField
                            disabled={this.isDisabled(index)}
                            className="textField"
                            value={row[".CHO.Em"]}
                            onChange={e => this.handleChange(e, index, '.CHO.Em')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                } else {
                    return <div className="text-wapper">
                        <div className="text-title">{name} Choice {index + 1} Email (Optional)</div>
                        <div>{row[".CHO.Em"]}</div>
                    </div>
                }
            }
        }
        const dragBoxView = () => {
            if (globalData.dragData && lock === false) {
                return <div id="dragBox" className={isCollision ? "dragBox c" : "dragBox2 c"}>+ Drag Tags to Here</div>
            }
        }
        const addBtnView = () => {
            if (lock === false) {
                return <Button disabled={this.isDisabled()} color="primary" onClick={this.handleAdd}>
                    <AddIcon></AddIcon> <b>ADD MORE {name.toUpperCase()}</b>
                </Button>
            }
        }
        return (
            <Root>
                {dataArr.map((row, index) => (
                    <div className="panel-wapper v" key={index}>
                        <div className="flow">
                            <div className="text-wapper">
                                <div className="text-title">{name} Choice {index + 1} {name2} Name</div>
                                <div>{row[".CHO.N."]}</div>
                            </div>
                            <div className="textWapper2">
                                <div className="text-title">{name} First Choice {index + 1} Relation to the {row["rc"]}</div>
                                <div>{row["rc"]} {row["relation"]}</div>
                            </div>
                            <div className="text-wapper">
                                <div className="text-title">{name} Choice {index + 1} {name2} Phone Number</div>
                                <div>{row[adrsPhoKey]["phone"]}</div>
                            </div>
                            <div className="text-wapper">
                                <div className="text-title">{name} Choice {index + 1} {name2} Choose The Country</div>
                                <div>{row[adrsPhoKey]["country"]}</div>
                            </div>
                            {unitView(row, index, false)}
                            <div className="text-wapper">
                                <div className="text-title">{name} Choice {index + 1} {name2} Street</div>
                                <div>{row[adrsPhoKey]["street"]}</div>
                            </div>
                            <div className="text-wapper">
                                <div className="text-title">{name} Choice {index + 1} {name2} City</div>
                                <div>{row[adrsPhoKey]["city"]}</div>
                            </div>
                            <div className="text-wapper">
                                <div className="text-title">{name} Choice {index + 1} {name2} State</div>
                                <div>{row[adrsPhoKey]["state"]}</div>
                            </div>
                            <div className="text-wapper">
                                <div className="text-title">{name} Choice {index + 1} {name2} Zip Code</div>
                                <div>{row[adrsPhoKey]["zipcode"]}</div>
                            </div>
                            {emailView(row, index, false)}
                        </div>
                        <div className="tool-view h h-r">
                            <Button size="small" color="primary" onClick={e => this.handleEdit(row)}>Edit</Button>
                        </div>
                        <div className="toolView h h-bt">
                            {showArrowBtn(index)}
                            {showDelBtn(index)}
                        </div>
                    </div>
                ))}
                {addBtnView()}
                {dragBoxView()}
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { haveEmail, spouseInfo, state, data } = this.props;
        const { dataArr } = this.state;
        if (!haveEmail) {
            for (const obj of dataArr) {
                delete obj[".CHO.Em"];
            }
        }
        // //add SpouseInfo
        if (data) {
            this.setState(() => ({
                dataArr: data
            }))
        } else {
            if (spouseInfo && state === ADD) {
                dataArr.length = 0;
                dataArr.push(spouseInfo);
                this.setState(() => ({
                    dataArr
                }))
                this.props.handleChange(dataArr);
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            const data = this.props.data;
            // const adrsPhoKey = this.props.adrsPhoKey;
            const rcKey = this.props.rcKey;
            if (data) {
                // let dataArr = this.extractData(data, adrsPhoKey);
                let dataArr = this.extractData2(data, rcKey);
                console.log("update dataArr", dataArr)
                this.setState(() => ({
                    dataArr
                }));
            }
        }
    }
    extractData(data, adrsPhoKey) {
        for (const obj of data) {
            let str = obj[adrsPhoKey];
            console.log(str)
            if (str) {
                let strArr = str.split(";");
                console.log(strArr)
                if (strArr.length === 7) {
                    obj["phone"] = strArr[0];
                    obj["unit"] = strArr[1];
                    obj["street"] = strArr[2];
                    obj["city"] = strArr[3];
                    obj["country"] = strArr[4];
                    obj["state"] = strArr[5];
                    obj["zipcode"] = strArr[6];
                    console.log(obj)
                    return data;
                }
            }
            obj["phone"] = "";
            obj["unit"] = "";
            obj["street"] = "";
            obj["city"] = "";
            obj["country"] = "";
            obj["state"] = "";
            obj["zipcode"] = "";
            return data;
        }
    }
    extractData2(data, rcKey) {
        for (const obj of data) {
            let str = obj[rcKey];
            if (str) {
                let strArr = str.split(";");
                if (strArr.length === 2) {
                    obj["rc"] = strArr[0];
                    obj["relation"] = strArr[1];
                }
            } else {
                obj["rc"] = "";
                obj["relation"] = "";
            }
        }
        return data;
    }
    handleChange(e, index, name) {
        const value = e.target.value;
        const { dataArr } = this.state;
        const { adrsPhoKey, rcKey } = this.props;
        dataArr[index][name] = value;
        if (name === "phone" || name === "unit"
            || name === "street" || name === "city"
            || name === "country" || name === "state"
            || name === "zipcode") {
            dataArr[index][adrsPhoKey][name] = value;
            // dataArr[index][adrsPhoKey] = dataArr[index]["phone"] + ";"
            //     + dataArr[index]["unit"] + ";"
            //     + dataArr[index]["street"] + ";"
            //     + dataArr[index]["city"] + ";"
            //     + dataArr[index]["country"] + ";"
            //     + dataArr[index]["state"] + ";"
            //     + dataArr[index]["zipcode"];
        } else if (name === "rc" || name === "relation") {
            dataArr[index][rcKey] = dataArr[index]["rc"] + ";" + dataArr[index]["relation"];
        }
        this.setState(() => ({
            dataArr
        }))
        console.log("click", dataArr)
        this.props.handleChange(dataArr);
    }
    handleAdd() {
        // const { dataArr } = this.state;
        // const { haveEmail, adrsPhoKey } = this.props;
        // let obj = {
        //     ".CHO.N.": "",
        //     "rc": "",
        //     "relation": "",
        // }
        // obj[adrsPhoKey] = {
        //     "phone": "",
        //     "unit": "",
        //     "street": "",
        //     "city": "",
        //     "country": "",
        //     "state": "",
        //     "zipcode": "",
        // }
        // if (haveEmail) obj[".CHO.Em"] = "";
        // let arr = dataArr;
        // arr.push(obj)
        // this.setState(() => ({
        //     dataArr: arr
        // }))
        this.props.addPanel();
    }
    handleArrow(e, index, type) {
        let dataArr = clone(this.state.dataArr);
        let index2 = 0;
        if (type === "up") {
            index2 = index - 1;
        } else if (type === "down") {
            index2 = index + 1;
        }
        [dataArr[index], dataArr[index2]] = [dataArr[index2], dataArr[index]];
        this.setState(() => ({
            dataArr
        }))
        this.props.handleChange(dataArr);
    }
    handleDelet(e, index) {
        let dataArr = clone(this.state.dataArr);
        dataArr.splice(index, 1);
        this.setState(() => ({
            dataArr
        }))
        this.props.handleChange(dataArr);
    }
    handleEdit(row) {
        this.props.handleOpenPanel(row);
    }
    getData() {
        return this.state.dataArr;
    }
    getContentRectData() {
        if (this.props.lock === true) return;
        if (this.props.dragData) {
            const dragBox = document.getElementById("dragBox");
            console.log("dragBoxdragBoxdragBox", dragBox)
            const dragBoxData = dragBox ? dragBox.getBoundingClientRect() : null;
            if (dragBoxData) {
                const obj = {
                    left: dragBoxData.left,
                    top: dragBoxData.top,
                    width: dragBox.offsetWidth,
                    height: dragBox.offsetHeight,
                }
                return obj;
            }
        }
        return null;
    }
    handleCollision() {
        this.setState(() => ({
            isCollision: true
        }));
    }
    handleLeave() {
        this.setState(() => ({
            isCollision: false
        }));
    }
    handleUp() {
        let dataArr = clone(this.state.dataArr);
        if (globalData.dragData && globalData.isCollision) {
            let dData = clone(globalData.dragData);
            if (dData.hasOwnProperty("P.H.Addr")) {
                dData[".CHO.AddrNPho"] = dData["P.H.Addr"];
                dData[".CHO.Addr"] = dData["P.H.Addr"];
            } else if (dData.hasOwnProperty("S.H.Addr.")) {
                dData[".CHO.AddrNPho"] = dData["S.H.Addr."];
                dData[".CHO.Addr"] = dData["S.H.Addr."];
            } else if (dData.hasOwnProperty(".CHO.AddrNPho")) {
                dData[".CHO.Addr"] = dData[".CHO.AddrNPho"];
            } else if (dData.hasOwnProperty(".CHO.Addr")) {
                dData[".CHO.AddrNPho"] = dData[".CHO.Addr"];
            }
            if (dataArr.length === 1) {
                let haveData = this.haveData(dataArr[0]);
                if (haveData) {
                    dataArr.push(dData);
                } else {
                    dataArr.length = 0;
                    dataArr.push(dData);
                }
            } else {
                dataArr.push(dData);
            }
            this.setState({
                dataArr,
            }, () => {
                this.props.handleChange(dataArr);
                globalData.dragData = null;
            })
        } else {
            globalData.dragData = null;
        }
        this.forceUpdate();
    }
    haveData(data) {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const obj = data[key];
                if (typeof obj === "object") {
                    if (this.haveData2(obj)) {
                        return true;
                    }
                } else if (obj !== "") {
                    return true;
                }
            }
        }
        return false;
    }
    haveData2(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const element = obj[key];
                if (element !== "") {
                    return true;
                }
            }
        }
        return false;
    }
    isDisabled(index) {
        const { lockNum } = this.props;
        if (index < lockNum) {
            return true;
        } else {
            return false;
        }
    }
}

export default AddMore;